import { message } from 'antd';
import { client } from '../../../actions';

export const ensureMaxPhone = async ({ login, password, phone }) => {
  try {
    const response = await client.post(
      '/TwoFactAuth/max/ensure_phone',
      { login, password, phone },
      {}
    );
    return response.data;
  } catch (e) {
    console.error(e);
    message.error('Не получилось сохранить телефон');
    return null;
  }
};
